import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/Slogo.jpeg";

const BrandLogo = ({ isScrolled }) => {
  return (
    <Link to="/" className="flex items-center space-x-3">
      <img
        src={logo}
        alt="Subrahmanya"
        className="h-10 w-10 sm:h-12 sm:w-12 rounded-full object-cover border-2 border-secondary"
      />
      <div className="flex flex-col">
        <h1
          className={`line-clamp-1 text-lg sm:text-2xl font-bold leading-none tracking-tight transition-colors duration-300 ${
            isScrolled ? "text-primary" : "text-white"
          }`}
        >
          SUBRAHMANYA
        </h1>
        <span
          className={`text-[10px] sm:text-[12px] font-medium tracking-[0.2em] transition-colors duration-300 ${
            isScrolled ? "text-secondary" : "text-secondary"
          }`}
        >
          RUDRAKSHA
        </span>
      </div>
    </Link>
  );
};

export default BrandLogo;
